import React, { useState } from "react";

const FAQSection = () => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleInputChange = (event) => {
    // Use a regular expression to allow only digits
    const newValue = event.target.value;
    if (/^\d*$/.test(newValue)) {
      setPhoneNumber(newValue);
    }
  };
  const handleButtonClick = () => {
    // Logic for handling button click, like sending the phone number to an API or displaying a link
    console.log("Phone number submitted:", phoneNumber);
  };

  return (
    <section className="bg-custom-green w-full py-8 mx-auto px-6">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        <p className="text-white text-xl text-center md:text-left">
          Let's go. Get a link to download the app.
        </p>
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 w-full md:w-auto">
          <input
            type="text" // Use type="text" to avoid automatic numeric input handling
            placeholder="Enter your phone number"
            className="py-2 px-4 rounded-md w-full md:w-auto"
            value={phoneNumber}
            onChange={handleInputChange}
          />
          <button
            className="bg-black text-white py-2 px-6 rounded-md w-full md:w-auto"
            onClick={handleButtonClick}
          >
            GET THE LINK
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
